import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import _ from 'lodash'
import { Row, Col } from 'antd'
import { Button } from '@vzmi/shp_shared_compo'
import { UPDATE_LISTING_FORM_KEY } from '../../../../constants/proposalTypes'
import CollapsePanel from '../../../Proposal/UpdateListing/CollapsePanel/CollapsePanel'
import styles from './index.css'
import { HyperLink } from '../../../Common/Form'
import { getUpdateListingPreviewPage } from '../../../Proposal/Common/ProposalForm/Shared/util'
import { EMPTY_VALUE } from '../../../../constants/globalTypes'
import { ConnectedListingLink } from '../../../Common/ListingLink/ListingLink'

const ListingCollapseBlock = props => {
  const {
    listings: listingsFromReduxForm,
    children,
    onRemove,
    onCollapseChange,
    listing: {
      id: listingId,
      name: listingName
    } = {},
    readOnly,
    proposalType,
    batchResult: {
      successProposalMap: successMap
    } = {},
    defaultExpanded = true
  } = props
  const isLastListing = _.size(listingsFromReduxForm) === 1
  const successProposal = _.get(successMap, listingId, {})
  const proposalId = _.get(successProposal, 'id', EMPTY_VALUE)
  const isUpdateSuccess = !_.isEmpty(successProposal)
  const listingPreviewUri = getUpdateListingPreviewPage(proposalId, proposalType)

  const onRemoveListing = (listingId, listings) => async (e) => {
    // prevent card collapse execute
    e.stopPropagation()
    onRemove(listingId, listings)
  }

  // prevent trigger collapse
  const onClickListingId = e => e.stopPropagation()

  return (
    <CollapsePanel
      className={styles.appendBlock}
      onChange={onCollapseChange}
      panelHeader={(
        <Row
          type='flex'
          align='middle'
          justify='space-between'
          className={styles.panelHeader}
        >
          <Col span={4}>
            賣場編號
            <div className={styles.listingId}>
              <ConnectedListingLink
                targetListingId={listingId}
                onClick={onClickListingId}
              >
                {listingId}
              </ConnectedListingLink>
            </div>
          </Col>
          <Col span={14}>
            賣場名稱
            <div className={styles.listingName}>
              {listingName}
            </div>
          </Col>
          {
            readOnly && isUpdateSuccess && (
              <Col span={3}>
                <HyperLink
                  target='_blank'
                  href={listingPreviewUri}
                  isButton
                >
                  <Button
                    data-role='listing-preview'
                    size='large'
                    onClick={(e) => e.stopPropagation()}
                  >
                    賣場預覽
                  </Button>
                </HyperLink>
              </Col>
            )}
          <Col span={3}>
            <Button
              data-role='remove-listing-from-batch-button'
              size='large'
              buttonType='outline'
              onClick={onRemoveListing(listingId, listingsFromReduxForm)}
              disabled={isLastListing || readOnly}
            >
              下次再改
            </Button>
          </Col>
        </Row>
      )}
      defaultExpanded={defaultExpanded}
    >
      {children}
    </CollapsePanel>
  )
}

const selector = formValueSelector(UPDATE_LISTING_FORM_KEY)
const ListingCollapseBlockWithReduxForm = connect(state => {
  return {
    listings: selector(state, 'listings')
  }
})(ListingCollapseBlock)

export default ListingCollapseBlockWithReduxForm
